document.addEventListener('key:options:ready', () => {
    document.querySelectorAll(".key_option_set .key_option_tb_render").forEach(container => {
        const newCounter = document.createElement("span");
        newCounter.className = "key_custom_counter";
        container.querySelector("label").appendChild(newCounter);

        const input = container.querySelector("input");
        const inputMaxLen = input.getAttribute("maxlength") || "∞";
        input.addEventListener("input", e => {
            console.log(`${e.target.value.length} | ${inputMaxLen}`)
            newCounter.textContent = `${e.target.value.length} | ${inputMaxLen}`;
        });
    });
});